"use client";

import { appArticleList } from "@/entities";
import { NewsCardBase } from "@/entities/dev/news/ui/NewsCardBase";
import { PageTitle } from "@/shared/app/ui/text/PageTitle";
import { useQuery } from "@tanstack/react-query";
import { useParams, useSearchParams } from "next/navigation";
import { AppPagination, Loader } from "@/shared";

export function NewsListPage() {
  const params = useParams<{ slug: string }>();
  const searchParams = useSearchParams();

  const slug = params?.slug || "";
  const state = searchParams?.get("state") || "";
  const common_category_id = searchParams?.get("common_category_id") || "";
  const keyword = searchParams?.get("keyword") || "";
  const page = parseInt(searchParams?.get("page") || "1");

  const perPage = 12;
  const filterParams = { keyword };

  const { error, isLoading, data } = useQuery({
    queryKey: [
      `app-articles`,
      { ...filterParams, slug, state, common_category_id, page, perPage },
    ],
    queryFn: () =>
      appArticleList({
        ...filterParams,
        slug,
        state,
        common_category_id,
        page,
        perPage,
      }),
  });

  if (error) return <></>;
  // if (isLoading) return <></>;

  return (
    <div className="border-t border-[#ECECEC] mt-[-2px]">
      <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-14 md:py-20">
        <PageTitle
          label="Stories of Change"
          description={"우리가 직접하는 활동,\n더 나은 삶을 향한 모든 발걸음"}
        />

        {isLoading ? (
          <Loader className="my-50" />
        ) : (
          <>
            {data?.count && data?.count > 0 ? (
              <>
                <div className="py-10 md:py-20 ">
                  {/* 리스트 */}
                  <ul className="flex flex-wrap gap-6">
                    {data?.result.map((item: any, index: number) => (
                      <li
                        key={index}
                        className="
                          w-[calc((100%-24px)/2)] 
                          min-[763px]:w-[calc((100%-24px)/2)] 
                          min-[992px]:w-[calc((100%-48px)/3)]
                          max-[762px]:w-full
                          rounded-lg flex-shrink-0
                          mb-5
                        "
                      >
                        <NewsCardBase item={item} />
                      </li>
                    ))}
                  </ul>

                  <div className="mt-24">
                    <AppPagination
                      total={Math.ceil(data?.count / perPage)}
                      page={page}
                      pathname="/app/news"
                      params={filterParams}
                    />
                  </div>
                </div>
              </>
            ) : (
              <p
                className="my-50 text-center tracking-tight text-lightGray-10"
                style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
              >
                등록된 데이터가 없습니다.
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
